import Rank from './src/main';

/* istanbul ignore next */
Rank.install = function(Vue) {
  Vue.component(Rank.name, Rank);
};

export default Rank;
